module.exports = __webpack_public_path__ + "static/media/TheIslandsofElsewhereBookCover.802f71e1.jpg";